import { render } from "./StationIdentify.vue?vue&type=template&id=02d96d04&scoped=true"
import script from "./StationIdentify.vue?vue&type=script&lang=js"
export * from "./StationIdentify.vue?vue&type=script&lang=js"

import "./StationIdentify.vue?vue&type=style&index=0&id=02d96d04&scoped=true&lang=less"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d96d04"]])

export default __exports__